import Vue from 'vue';
import Router from 'vue-router';
import LoginScreen from '@/components/modules/authentication/LoginScreen';
import PasswordResetScreen from '@/components/modules/authentication/PasswordResetScreen';
import SetPasswordScreen from '@/components/modules/authentication/SetPasswordScreen';
import RegistrationScreen from '@/components/modules/authentication/RegistrationScreen';
import DashboardScreen from '@/components/modules/dashboard/DashboardScreen';
import SitesScreen from '@/components/modules/partners/SitesScreen';
import DetailedSiteScreen from '@/components/modules/partners/DetailedSiteScreen';
import CriteriaCategoriesScreen from '@/components/modules/criteria_categories/CriteriaCategoriesScreen';
import DocumentsScreen from '@/components/modules/documents/DocumentsScreen';
import TasksScreen from '@/components/modules/tasks/TasksScreen';
import InspectionsScreen from '@/components/modules/inspections/InspectionsScreen';
import InspectionPlanningScreen from '@/components/modules/inspections/InspectionPlanningScreen';
import InspectionFinalisationScreen from '@/components/modules/inspections/InspectionFinalisationScreen';
import FinalizedInspectionScreen from '@/components/modules/inspections/FinalizedInspectionScreen';
import BaseStatesScreen from '@/components/modules/base_states/BaseStatesScreen';
import BaseStatePlanningScreen from '@/components/modules/base_states/BaseStatePlanningScreen';
import BaseStateEditScreen from '@/components/modules/base_states/BaseStateEditScreen';
import PreviousBaseStatesScreen from '@/components/modules/base_states/PreviousBaseStatesScreen';
import FeedScreen from '@/components/modules/helpdesk/FeedScreen';
import NoteScreen from '@/components/modules/helpdesk/NoteScreen';
import StatementHistoryScreen from '@/components/modules/inspections/StatementHistoryScreen';
import PartnersScreen from '@/components/modules/partners/PartnersScreen';

import store from '@/store/store';


Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'LoginScreen',
      component: LoginScreen,
      meta: {
        withoutAuth: true,
      },
    },
    {
      path: '/password_reset',
      name: 'PasswordResetScreen',
      component: PasswordResetScreen,
      meta: {
        withoutAuth: true,
      },
    },
    {
      path: '/set_password/:resetToken',
      name: 'SetPasswordScreen',
      component: SetPasswordScreen,
      meta: {
        withoutAuth: true,
      },
    },
    {
      path: '/registration/:invitationCode',
      name: 'RegistrationScreen',
      component: RegistrationScreen,
      meta: {
        withoutAuth: true,
      },
    },
    {
      path: '/dashboard',
      name: 'DashboardScreen',
      component: DashboardScreen,
      alias: '/',
    },
    {
      path: '/sites',
      name: 'SitesScreen',
      component: SitesScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'admin' || store.getters.loggedInUser.role === 'partner_admin') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/sites/:id',
      name: 'DetailedSiteScreen',
      component: DetailedSiteScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'worker') {
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/criteria_categories/:id?',
      name: 'CriteriaCategoriesSreen',
      component: CriteriaCategoriesScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'admin' || store.getters.loggedInUser.role === 'partner_admin') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/documents',
      name: 'DocumentsScreen',
      component: DocumentsScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'worker') {
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/tasks/:id?',
      name: 'TasksScreen',
      component: TasksScreen,
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: '/inspections',
      name: 'InspectionsScreen',
      component: InspectionsScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'worker') {
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/inspections/create',
      name: 'InspectionPlanningScreen',
      component: InspectionPlanningScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'admin' || store.getters.loggedInUser.role === 'vivu' || store.getters.loggedInUser.role === 'partner_admin') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/inspections/:id/edit',
      name: 'InspectionEditScreen',
      component: InspectionPlanningScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'admin' || store.getters.loggedInUser.role === 'vivu' || store.getters.loggedInUser.role === 'partner_admin') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/inspections/:id',
      name: 'InspectionFinalisationScreen',
      component: InspectionFinalisationScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'admin' || store.getters.loggedInUser.role === 'partner_admin' || store.getters.loggedInUser.role === 'vivu') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/inspections/:id/report',
      name: 'InspectionReportScreen',
      component: FinalizedInspectionScreen,
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: '/inspections/:id/history',
      name: 'StatementHistoryScreen',
      component: StatementHistoryScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'admin' || store.getters.loggedInUser.role === 'partner_admin') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/base_states',
      name: 'BaseStatesScreen',
      component: BaseStatesScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'worker') {
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/base_states/plan_base_state',
      name: 'BaseStatePlanningScreen',
      component: BaseStatePlanningScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'admin' || store.getters.loggedInUser.role === 'vivu' || store.getters.loggedInUser.role === 'partner_admin') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/base_states/edit_base_state',
      name: 'BaseStateEditScreen',
      component: BaseStateEditScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role !== 'vivu') {
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/base_states/previous_base_states/:id?',
      name: 'PreviousBaseStatesScreen',
      component: PreviousBaseStatesScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role !== 'vivu') {
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/feeds',
      name: 'FeedScreen',
      component: FeedScreen,
    },
    {
      path: '/notes',
      name: 'NoteScreen',
      component: NoteScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'admin') {
          next('/');
        } else {
          next();
        }
      },
    },
    {
      path: '/partners',
      name: 'PartnersScreen',
      component: PartnersScreen,
      beforeEnter: (to, from, next) => {
        if (store.getters.loggedInUser.role === 'super_admin') {
          next();
        } else {
          next('/');
        }
      },
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.withoutAuth)) {
    if (store.getters.loggedInUser) {
      next('/');
    } else {
      next();
    }
  } else {
    if (to.name === 'PartnersScreen' && store.getters.loggedInUser && store.getters.loggedInUser.role !== 'super_admin') {
      next('/');
      return;
    }
    if (store.getters.loggedInUser && store.getters.loggedInUser.role === 'super_admin' && to.name !== 'PartnersScreen') {
      next('/partners');
      return;
    }
    if (store.getters.loggedInUser) {
      next();
      return;
    }
    next('/login');
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js